import ajaxRequest from './ajax'
import qs from "qs"

export const query_tags = params => {
    return ajaxRequest.get("common/tag/query_tags?" + qs.stringify(params))
}

//权限：客户联络员 创建或者修改标签
export const insert_or_update_tag = params => {
  return ajaxRequest.post("common/tag/insert_or_update_tag", params);
}



// WEBPACK FOOTER //
// ./src/api/tag.js